//const SERVER_BASE_URL = 'http://localhost:3001'
 const SERVER_BASE_URL = 'https://magtymgulyteatr.gov.tm'

export default SERVER_BASE_URL
